// src/components/CategoryMenu.jsx
import React, { useRef, useLayoutEffect } from "react";

const CategoryMenu = ({ categories, currentCategory, onChangeCategory }) => {
  const containerRef = useRef(null);
  const itemRefs = useRef([]);
  const lastActionRef = useRef("init"); // "init" | "url" | "click"

  useLayoutEffect(() => {
    const container = containerRef.current;
    if (!container || categories.length === 0) return;

    const idx = categories.findIndex((c) => c.category === currentCategory);
    if (idx < 0) return;

    const item = itemRefs.current[idx];
    if (!item) return;

    const smooth = lastActionRef.current === "click";

    // 1) Let browser scroll the item into view centered
    try {
      item.scrollIntoView({
        behavior: smooth ? "smooth" : "auto",
        inline: "center",
        block: "nearest",
      });
    } catch {
      // Safari fallback if needed
      item.scrollIntoView(smooth);
    }

    // 2) Clamp for first/last so scrollbar doesn't "half center" edges
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    if (idx === 0) {
      container.scrollTo({ left: 0, behavior: smooth ? "smooth" : "auto" });
    } else if (idx === categories.length - 1) {
      container.scrollTo({
        left: maxScrollLeft,
        behavior: smooth ? "smooth" : "auto",
      });
    }

    // after one smooth click, future URL changes should be instant
    lastActionRef.current = "url";
  }, [currentCategory, categories]);

  const handleClick = (cat) => {
    lastActionRef.current = "click";
    onChangeCategory(cat.category);
  };

  return (
    <nav className="category-menu" ref={containerRef}>
      {categories.map((cat, index) => (
        <button
          key={cat.category}
          ref={(el) => (itemRefs.current[index] = el)}
          className={
            "category-pill" +
            (currentCategory === cat.category ? " active" : "")
          }
          onClick={() => handleClick(cat)}
        >
          {cat.displayTitle}
        </button>
      ))}
    </nav>
  );
};

export default CategoryMenu;
